const signup = {
  invalidToken: 'Invalid invitation token. Please check the link or request a new invitation.',
  invitationAccepted: 'Invitation accepted successfully. Welcome aboard!',
  unknownError: 'Oops! Something went wrong.',
  conflictEmailOrPhone: 'Signup email or phone number is already in use by another moderator.',
  signupTitle: 'Join Your Team!',
  submitBtn: 'Join Now',
  signupSuccessful: 'You have successfully signed up to Moovex!',
  signupFailed: 'Something went wrong. Please try again or contact michael@moovex.com',
  backToLogin: 'Continue to login',
  phoneInvalid: 'Phone number is invalid.',
  firstName: 'First Name',
  lastName: 'Last Name',
  phone: 'Phone',
  email: 'Email',
  createPassword: 'Create Password',
  confirmPassword: 'Confirm Password',
  success: {
    redirectIn: 'You will be redirected in ',
    seconds: ' seconds',
  },
};

export default signup;
